import React, { useEffect, useRef } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/mob.css';
import appstoreIcon from '../assets/icons/appstore.png';
import gplayIcon from '../assets/icons/gplay.png';
import mobImage from '../assets/images/mob.jpg';
import mob2Image from '../assets/images/mob2.jpg';

const Mob = () => {
  const { isDarkMode } = useTheme();
  const sectionRef = useRef(null);

  // Scroll event listener'ı kaldırıldı - artık gerekli değil

  // Intersection Observer ile animasyonları tetikle
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-on-scroll');
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    // Animasyon yapılacak elementleri gözlemle
    const animatedElements = sectionRef.current?.querySelectorAll('.mob-header, .feature-card, .download-content, .mobile-preview');
    animatedElements?.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: '📱',
      title: 'Anlık Takip',
      description: 'Altın ve döviz fiyatlarını anlık olarak cep telefonunuzdan izleyebilir, piyasadaki değişimleri anında görebilirsiniz.'
    },
    {
      icon: '⚡',
      title: 'Sade ve Hızlı Arayüz',
      description: 'Karmaşadan uzak, sade tasarımı sayesinde fiyatları anında bulabilir, uygulamayı kolayca kullanabilirsiniz.'
    },
    {
      icon: '⭐',
      title: 'Favoriler',
      description: 'Sık takip ettiğiniz ürünleri favorilerinize ekleyerek tek dokunuşla hızlı erişim sağlayabilir, portföyünüze özel takip listesi oluşturabilirsiniz.'
    },
    {
      icon: '🔄',
      title: 'Çeviri Aracı',
      description: 'Belirttiğiniz miktarı girerek anlık kur bilgisine göre Türk Lirası, Dolar ve Euro karşılıklarını kolayca hesaplayabilirsiniz.'
    },
    {
      icon: '🌙',
      title: 'Karanlık Mod Desteği',
      description: 'Gece veya loş ortamlarda göz yormayan karanlık mod seçeneğiyle kullanıcı deneyiminizi kişiselleştirin.'
    }
  ];

  return (
    <section 
      ref={sectionRef}
      className={`mob-section ${isDarkMode ? 'dark-mode' : ''}`}
    >
      <div className="container">
        <div className="mob-header">
          <h2>Mobil Uygulaması</h2>
          <p>ENG Kıymetli Madenler mobil uygulaması ile piyasaları her yerden takip edin</p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="download-section">
          <div className="download-content">
            <h3>Hemen İndirin</h3>
            <p>App Store ve Google Play'den ücretsiz indirin</p>
            <div className="download-buttons">
              <a 
                href="https://apps.apple.com/us/app/eng-kıymetli-madenler/id6751402030" 
                target="_blank" 
                rel="noopener noreferrer"
                className="download-btn app-store"
              >
                <img src={appstoreIcon} alt="App Store" />
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.aifasoft.eng&hl=tr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="download-btn google-play"
              >
                <img src={gplayIcon} alt="Google Play" />
              </a>
            </div>
          </div>
          
          <div className="mobile-preview">
            <div className="phone-mockup">
              <img src={mobImage} alt="Mobil Uygulama Önizleme 1" className="mobile-screenshot" />
            </div>
            <div className="phone-mockup">
              <img src={mob2Image} alt="Mobil Uygulama Önizleme 2" className="mobile-screenshot" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mob;
